import clsx from 'clsx';
import { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface FilterButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  children: ReactNode;
}

export const FilterButton: React.FC<FilterButtonProps> = ({ children, className, type = 'button', ...props }) => (
  <button
    {...props}
    className={twMerge(
      clsx(
        'flex items-center gap-2 rounded-full px-5 py-2.5 text-center text-sm font-medium sm:py-3 sm:text-base md:font-normal',
        'border border-gray-200 bg-white',
        'hover:shadow-lg',
        className,
      ),
    )}
    type={type}>
    {children}
  </button>
);

export default FilterButton;
